<!-- eslint-disable max-len -->
<template>
  <div
    :id="id"
    class="modal-field-list-view"
  >
    <!-- Title -->
    <div class="modal-title">
      <h4 class="title">
        Properties
        <div class="title-badge">Field on List View</div>
      </h4>

      <div class="wrap-type">
        <img :src="require(`@/assets/new-form-ui/field-icon/${dataField.field === 'icon' ? 'image' : 'field'}.svg`)">
        <div class="text-type">{{ dataField.field.replace('text', 'field').split('_').join(' ') }}</div>
      </div>
    </div>

    <!-- Modal Content -->
    <div class="wrap-content">
      <!-- Format Section -->
      <div
        v-if="dataField.field !== 'icon'"
        class="section-field input-field"
      >
        <b-form :class="{'error-input' : $v.dataSetup.type.$error}">
          <label> Format </label>
          <j-single-select
            v-model="dataSetup.type"
            :custom="true"
            :options="formatOptions"
            placeholder="Select format"
          >
            <template
              slot-scope="node"
              slot="node-custom"
            >
              <img
                :src="require(`@/assets/icon/column-type/${setIconType(node.node.id)}.svg`)"
                style="width:14px;height:auto;margin-right:5px;"> {{ node.node.label }}
            </template>
          </j-single-select>
        </b-form>

        <!-- Timezone field -->
        <b-form
          v-if="dataSetup.type === 'datetime' ||
            dataSetup.type === 'time' ||
            dataSetup.type === 'dd-mmm-yyyy' ||
            dataSetup.type === 'mmmm dd, yyyy' ||
            dataSetup.type === 'MMMM dd, yyyy'
          "
        >
          <label> Timezone </label>
          <j-single-select
            v-model="dataSetup.timezone"
            :options="listTimezone"
            :placeholder="'Select Timezone'"
            label="text"
            value-format="object"
          />
        </b-form>
      </div>

      <!-- Parse Variable -->
      <div
        v-if="dataField.field !== 'icon'"
        class="section-field input-field"
      >
        <p class="title-section">Parse Value To</p>

        <b-form :class="{'error-input' : $v.dataSetup.variable.$error}">
          <label> Column </label>
          <j-single-select
            v-model="dataSetup.variable"
            :options="variableOptionsFiltered"
            :placeholder="'Select Column'"
            :disabled="!dataSetup.type"
            label="label"
          />
        </b-form>
      </div>

      <!-- Timezone field -->
      <b-form v-if="dataSetup.type === 'text' && parseValueTimer">
        <label> Timezone </label>
        <j-single-select
          v-model="dataSetup.timezone"
          :options="listTimezone"
          :placeholder="'Select Timezone'"
          label="text"
          value-format="object"
        />
      </b-form>

      <!-- If Setup Icon -->
      <div
        v-if="dataField.field === 'icon'"
        class="configuration-section"
      >
        <h4 class="configuration-section-title">Icon Source</h4>
        <p class="configuration-section-desc">
          Select the type of source file used to be used as an icon on the list item
        </p>

        <div class="d-flex align-items-center">
          <div
            v-for="icon in iconOptions"
            :key="icon.id"
            :class="{ 'active': icon.id === iconSource }"
            class="div-list-icon-source"
            @click="iconSource = icon.id"
          >
            {{ icon.name }}
          </div>
        </div>

        <!-- Upload -->
        <div
          v-if="iconSource === 'upload'"
          :class="{'error-input' : $v.dataIconSourceUpload.$error}"
          class="icon-configuration"
        >
          <div class="wrap-icon">
            <div class="div-icon">
              <input
                ref="fileInput"
                type="file"
                @change="handleUpload"
              >
              <img
                v-show="dataIconSourceUpload && dataIconSourceUpload.includes('http')"
                :src="dataIconSourceUpload"
              >
              <img
                v-show="!dataIconSourceUpload"
                style="width: 15px; height: 15px"
                src="@/assets/new-form-ui/default-icon.svg">
            </div>
            <div class="ml-2">
              <p class="icon-name">{{ dataIconSourceUpload || 'No File Uploaded' }}</p>
              <!-- iF have url icon -->
              <div
                v-if="dataIconSourceUpload"
                class="d-flex align-items-center">
                <p
                  class="icon-change mr-3"
                  @click="clearIcon"
                >
                  Clear
                </p>
                <p
                  class="icon-change"
                  @click="changeIcon"
                >
                  Change
                </p>
              </div>

              <!-- if not have url icon -->
              <p
                v-else
                class="icon-change"
                @click="changeIcon"
              >
                Upload
              </p>
            </div>
          </div>
        </div>

        <div
          v-else
          class="icon-configuration"
        >
          <p class="title-section">Parse Value To</p>
          <b-form :class="{'error-input' : $v.dataIconSourceColumn.$error}">
            <label> Column </label>
            <j-single-select
              v-model="dataIconSourceColumn"
              :options="variableOptions"
              :placeholder="'Select Column'"
              label="label"
            />
          </b-form>
        </div>
      </div>
    </div>

    <!-- Button -->
    <div class="d-flex justify-content-end mt-2">
      <button
        class="button-border mr-2"
        @click="$emit('close-modal')"
      >
        Close
      </button>
      <button
        class="button-blue"
        @click="submitForm"
      >
        Apply
      </button>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-lonely-if */
import axios from 'axios';
import { mapActions } from 'vuex';
import { requiredIf } from 'vuelidate/lib/validators';
// Data
import timezone from '@/assets/file/timezone.json';

export default {
  props: {
    id: {
      type: String,
      default: '',
    },
    variableOptions: {
      type: Array,
      default: () => [],
    },
    dataField: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      isFirstLoad: true,
      iconSource: 'upload',
      dataSetup: {
        type: null,
        variable: null,
        url: null,
        timezone: null,
      },
      dataIconSourceUpload: null,
      dataIconSourceColumn: null,
      formatOptions: [
        {
          id: 'text',
          text: 'Text',
        },
        {
          id: 'currency',
          text: 'Currency',
        },
        {
          id: 'currency_selection',
          text: 'Currency Selection',
        },
        {
          id: 'datetime',
          text: 'Date Time',
        },
        {
          id: 'time',
          text: 'Time',
        },
        {
          id: 'dd-mmm-yyyy',
          text: 'Date (dd-mmm-yyyy)',
        },
        {
          id: `${this.type === 'export' ? 'MMMM' : 'mmmm'} dd, yyyy`,
          text: 'Date (mmmm dd, yyyy)',
        },
      ],
      iconOptions: [
        {
          id: 'upload',
          name: 'Upload',
        },
        {
          id: 'column',
          name: 'Column',
        },
      ],
      variables: [],
      acceptedFiles: ['jpg', 'png', 'jpeg', 'bmp', 'svg'],
      maxFileSize: 5000,
      api: JSON.parse(localStorage.getItem('Token')).value,
    };
  },

  computed: {
    url_upload() {
      return `${process.env.GATE_URL}/file`;
    },

    variableOptionsFiltered() {
      if (this.dataSetup.type === 'currency') {
        return this.variables.filter(f => f.type === 'number');
      } else if (this.dataSetup.type === 'currency_selection') {
        return this.variables.filter(f => f.type === 'object');
      } else if (this.dataSetup.type === 'datetime' ||
                this.dataSetup.type === 'time' ||
                this.dataSetup.type === 'dd-mmm-yyyy' ||
                this.dataSetup.type === `${this.type === 'export' ? 'MMMM' : 'mmmm'} dd, yyyy`) {
        return this.variables.filter(f => f.type === 'timestamp');
      }
      return this.variables.filter(f => f.type !== 'timestamp');
    },

    listTimezone() {
      return timezone.map((zone) => {
        // eslint-disable-next-line no-param-reassign
        zone.id = zone.utc;
        return zone;
      });
    },

    parseValueTimer() {
      // eslint-disable-next-line max-len
      const findIndex = this.variableOptionsFiltered.findIndex(v => v.id === this.dataSetup.variable);
      if (findIndex > -1) return this.variableOptionsFiltered[findIndex].type === 'timer';
      return false;
    },
  },

  watch: {
    // eslint-disable-next-line
    'dataSetup.type': function () {
      if (!this.isFirstLoad) this.dataSetup.variable = null;
    },
  },

  created() {
    if (this.dataField) {
      if (this.dataField.field === 'icon') {
        if (this.dataField.url && this.dataField.url.includes('http')) {
          this.iconSource = 'upload';
          this.dataIconSourceUpload = this.dataField.url;
        } else if (this.dataField.url && !this.dataField.url.includes('http')) {
          this.iconSource = 'column';
          this.dataIconSourceColumn = this.dataField.url;
        } else {
          this.iconSource = 'upload';
          this.dataIconSourceUpload = this.dataField.url;
        }
        this.dataSetup.url = null;
        delete this.dataSetup.type;
        delete this.dataSetup.variable;
      } else {
        this.dataSetup.type = this.dataField.type;
        this.dataSetup.variable = this.dataField.variable;
        delete this.dataSetup.url;
      }
    }

    if (this.dataField.timezone) {
      this.dataSetup.timezone = this.dataField.timezone ?
        { ...this.dataField.timezone, id: this.dataField.timezone.utc } :
        null;
    }

    if (this.dataField.field === 'text_3' || this.dataField.field === 'text_4') {
      this.variables = this.variableOptions.filter(f => f.type !== 'timer');
    } else {
      this.variables = this.variableOptions;
    }

    if (process.env.DISABLE_CURRENCY_SELECTION === 'true') {
      this.formatOptions = this.formatOptions.filter(option => option.id !== 'currency_selection');
    }

    setTimeout(() => {
      this.isFirstLoad = false;
    }, 300);
  },

  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleProblem', 'showLoading', 'hideLoading']),

    setIconType(type) {
      const convertType = type.toLowerCase();
      let finalType = '';
      if (convertType === 'date' || convertType === 'mmmm dd, yyyy' || convertType === 'MMMM dd, yyyy' || convertType === 'dd-mmm-yyyy') {
        finalType = 'date';
      } else {
        finalType = convertType;
      }
      return finalType;
    },

    clearIcon() {
      this.dataIconSourceUpload = null;
      this.$refs.fileInput.value = '';
    },

    changeIcon() {
      this.$refs.fileInput.click();
    },

    getBase64(file) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
      });
    },

    handleUpload(e) {
      if (e.target.files) {
        const file = e.target.files[0];
        const fileName = file.name;
        const fileSize = file.size;
        const extension = fileName.substring(fileName.lastIndexOf('.') + 1).toLowerCase();

        // Check file type
        let isAccepted = false;
        this.acceptedFiles.forEach((type) => {
          if (type === extension) {
            isAccepted = true;
          }
        });

        // Check file size
        let isSizeAccepted = false;
        if (fileSize < this.maxFileSize * 1000) {
          isSizeAccepted = true;
        }

        if (isAccepted && isSizeAccepted) {
          this.uploadFile(file);
        } else {
          if (!isAccepted) {
            this.clearIcon();
            this.hideLoading();
            this.toggleProblem('Please choose a wanted file!');
          }
          if (!isSizeAccepted) {
            this.clearIcon();
            this.hideLoading();
            this.toggleProblem(`Please upload a file less than ${this.maxFileSize / 1000}MB!`);
          }
          if (!isSizeAccepted && !isAccepted) {
            this.clearIcon();
            this.hideLoading();
            this.toggleProblem('Please choose a wanted file!');
          }
        }
      }
    },

    async uploadFile(file) {
      this.showLoading();
      const imageBase = await this.getBase64(file).then(
        data => data,
      );
      const commaPosition = imageBase.lastIndexOf(',') + 1;
      const imageData = imageBase.substring(commaPosition);
      let sendData = {};
      sendData = {
        filename: file.name,
        content: imageData,
      };
      axios.post(this.url_upload, sendData, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: this.api,
        },
      }).then((res) => {
        const data = res.data.data;
        this.dataIconSourceUpload = data.url;
        this.hideLoading();
      }).catch((error) => {
        this.clearIcon();
        this.hideLoading();
        this.toggleProblem(error.response.data.message);
      });
    },

    submitForm() {
      this.$v.dataSetup.$touch();
      if (!this.$v.dataSetup.$error) {
        if (this.dataField.field === 'icon') {
          if (this.iconSource === 'upload') this.dataSetup.url = this.dataIconSourceUpload;
          else if (this.iconSource === 'column') this.dataSetup.url = this.dataIconSourceColumn;
        }
        this.$emit('submit', this.dataSetup);
      }
    },
  },

  validations() {
    return {
      dataSetup: {
        type: {
          required: requiredIf(() => this.dataField.field !== 'icon'),
        },
        variable: {
          required: requiredIf(() => this.dataField.field !== 'icon'),
        },
      },
      dataIconSourceUpload: {
        required: requiredIf(() => this.dataField.field === 'icon' && this.iconSource === 'upload'),
      },
      dataIconSourceColumn: {
        required: requiredIf(() => this.dataField.field === 'icon' && this.iconSource === 'column'),
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/popup/ModalFieldListView.vue